import { msalInstance, scopedAuthRequest } from '../config/azureAd';

export const getFetchHeaders = async (headers = {}) => {
  const MillisecondsToSecondsFactor = 1000;
  const FiveMinutesInSeconds = 300;

  const activeAccount =
    msalInstance.activeAccount || (msalInstance.getAllAccounts() || [])[0];

  // MSAL will grab a non-cached token based on the access token, not the id token.
  // The Id token can expire before the access token.
  // A non expired Id token is needed based on API setup with Users API, so force
  // a non-cached token call if within 5 minutes of expiration.
  const forceRefreshToken =
    activeAccount?.idTokenClaims?.exp <
    Date.now() / MillisecondsToSecondsFactor + FiveMinutesInSeconds;


  let idToken;
  try {
    const response = await msalInstance.acquireTokenSilent({
      ...scopedAuthRequest,
      account: activeAccount,
      forceRefresh: forceRefreshToken,
    });
    idToken = response.idToken;
  } catch (e) {
    await msalInstance.loginRedirect();
  }

  if (idToken) {
    return {
      ...headers,
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
      Authorization: `Bearer ${idToken}`,
    }
  }
  return headers;
}